export default __webpack_public_path__ + "static/media/cultureimg.62ae1a67.jpg";